import { GpuCardIcon } from "@carbon6/c6-frontend-design";
import { gpuUnavailableForAnnotationReason } from "@/components/gpu";
import styles from "./AnnotationSetLockOverlay.module.css";

/**
 * GPU holder 가 하나도 없을 때 도구 섹션 위에 덮는 층. 확정 세트 잠금(`AnnotationSetLockOverlay`)과
 * 같은 자리와 같은 카드 배경을 쓴다. 이 층에는 사용자가 잠금을 해제하는 방법이 없다. GPU 가
 * 생기면 폴링이 이 층을 자동으로 제거한다.
 *
 * c6 스튜디오의 `authoringAvailability` 도 같은 사유를 가진다. 하지만 c6 는 선택이나 draft 가
 * 바뀔 때만 그 값을 다시 조회한다(캐시). GPU 는 그 사이에 사라질 수 있다. 그래서 현재 사유를
 * 화면에 표시하는 일은 앱이 담당한다. 캡처 자체는 c6 가 동작 시점에 driver 에 다시 물어 막는다.
 */
export function AnnotationGpuLockOverlay() {
  return (
    <div className={styles.card} role="status">
      <span className={styles.heading}>
        <GpuCardIcon aria-hidden="true" />
        지금은 GPU 가 없습니다
      </span>
      <p className={styles.body}>{gpuUnavailableForAnnotationReason.ko}</p>
    </div>
  );
}
